@if (dialogData) {
    <adapt-dialog [maxWidth]="600"
                  [expandable]="false"
                  [showHelpButton]="false"
                  [minimal]="true">
        <div adapt-dialog-content>
            @if (dialogData.headingIcon) {
                <h1 class="mb-4">
                    <i [ngClass]="dialogData.headingIcon"></i>
                </h1>
            }
            <h2 [innerHtml]="dialogData.title"></h2>
            @if (dialogData.message) {
                <div [froalaView]="dialogData.message"></div>
            }
            <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
            @if (dialogData.checkboxMessage) {
                <div class="mt-3">
                    <dx-check-box [value]="checkboxConfirmation"
                                  (valueChange)="checkboxConfirmation = $any($event)"
                                  [text]="dialogData.checkboxMessage"
                                  data-test="confirm-checkbox"></dx-check-box>
                </div>
            }
            <div class="inner-dialog-footer mt-5">
                <div class="d-flex flex-grow-1 justify-content-center gap-3">
                    <button adaptButton="primary"
                            [disabled]="!checkboxConfirmation"
                            (click)="confirm()"
                            data-test="standard-dialog-save-button">
                        {{ dialogData.confirmButtonText }}
                    </button>
                </div>
                @if (!dialogData.hideCancelButton) {
                    <div class="mt-4 d-flex flex-grow-1 justify-content-center gap-3">
                        <a role="button"
                           data-test="standard-dialog-cancel-button"
                           (click)="cancel()">{{ dialogData.cancelButtonText }}</a>
                    </div>
                }
            </div>
        </div>
    </adapt-dialog>
}

<ng-template #projectedContent>
    <ng-content></ng-content>
</ng-template>
